import * as React from "react";

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.70001 5.70001V3.36668C5.70001 2.43326 5.70001 1.96655 5.88167 1.61003C6.04145 1.29642 6.29642 1.04145 6.61003 0.88167C6.96655 0.700012 7.43326 0.700012 8.36668 0.700012H14.7C15.6334 0.700012 16.1002 0.700012 16.4567 0.88167C16.7703 1.04145 17.0253 1.29642 17.185 1.61003C17.3667 1.96655 17.3667 2.43326 17.3667 3.36668V9.70001C17.3667 10.6334 17.3667 11.1002 17.185 11.4567C17.0253 11.7703 16.7703 12.0253 16.4567 12.185C16.1002 12.3667 15.6334 12.3667 14.7 12.3667H12.3667M3.36668 17.3667H9.70001C10.6334 17.3667 11.1002 17.3667 11.4567 17.185C11.7703 17.0253 12.0253 16.7703 12.185 16.4567C12.3667 16.1002 12.3667 15.6334 12.3667 14.7V8.36668C12.3667 7.43326 12.3667 6.96655 12.185 6.61003C12.0253 6.29642 11.7703 6.04145 11.4567 5.88167C11.1002 5.70001 10.6334 5.70001 9.70001 5.70001H3.36668C2.43326 5.70001 1.96655 5.70001 1.61003 5.88167C1.29642 6.04145 1.04145 6.29642 0.88167 6.61003C0.700012 6.96655 0.700012 7.43326 0.700012 8.36668V14.7C0.700012 15.6334 0.700012 16.1002 0.88167 16.4567C1.04145 16.7703 1.29642 17.0253 1.61003 17.185C1.96655 17.3667 2.43325 17.3667 3.36668 17.3667Z"
      stroke="#98A2B3"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CopyIcon;
